import Vue from 'vue'
import Vuex from 'vuex'

import router from '@/router/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        "accesses": [],
        "authenticated": false,
        "selected_app_user": {uid:'', lastname:'', firstname:''},
        "selected_company": {uid:'', name:''},
        "user_datas": null,
        "unity_options": [
            {value:1, label:'Heure(s)'},
            {value:2, label:'Jour(s)'},
            {value:3, label:'Mois'},
            {value:4, label:'Année(s)'}
        ],
        "day_part_options": [
            {value:0, label:"Matin"},
            {value:1, label:"Après-midi"}
        ],
        "state_classes": {
            'accepte': 'label-success',
            'refuse': 'label-danger',
            'en_cours': 'label-warning',
            'annulation_demandee': 'cancel_asked',
            'annule': 'canceled',
            'brouillon': 'canceled',
            'transmis': 'label-warning'
        },
        "evp_state_classes": {
            'accepte': 'label-success',
            'refuse': 'label-danger',
            'en_cours': 'canceled',
            'transmis': 'label-warning'
        },
        "state_choice_set": {},
        "graduate_level_choice_set": {},
        "employee_status_choice_set": {},
        "distribution_set": {},
        "new_content": false,
    },
    getters: {
        current_company: (state)=> {
            var ls_sc = {}
            if(state.selected_company.uid != ''){
                return state.selected_company
            }
            ls_sc = JSON.parse(localStorage.getItem('selected_company'))
            if(ls_sc != null && ls_sc.uid != ''){
                return ls_sc
            }
            console.log("GETTERS CC PUSH")
            if(router.currentRoute.name != "dashboard"){
                router.push({name:"dashboard"})
            }
        },
        current_app_user: (state)=> {
            var ls_sau = {}
            if(state.selected_app_user.uid != ''){
                return state.selected_app_user
            }
            ls_sau = JSON.parse(localStorage.getItem('selected_app_user'))
            if(ls_sau != null && ls_sau.uid != ''){
                return ls_sau
            }
            console.log("GETTERS CAU PUSH")
            if(router.currentRoute.name != "dashboard"){
                router.push({name:"dashboard"})
            }
        }
    },
    mutations: {
        authenticate: (state)=> {
            // console.log("AUTHENTICATE")
            state.authenticated = true
        },
        logout: (state)=> {
            state.authenticated = false
            // localStorage.setItem("authenticated", false)
            state.user_datas = {app_user:{}, company:{}, profiles:[], accesses:[]}
            localStorage.setItem("selected_company", JSON.stringify({uid:'',name:''}))
            localStorage.setItem('selected_app_user', JSON.stringify({uid:'',lastname:'',firstname:''}))
        },
        not_authenticate: (state)=> {
            // console.log("NOT AUTHENTICATE")
            localStorage.setItem('selected_company', JSON.stringify({uid:'',name:''}))
            localStorage.setItem('selected_app_user', JSON.stringify({uid:'',lastname:'',firstname:''}))
            state.authenticated = false
        },
        set_accesses: (state, datas)=> {
            datas = datas.map(x => x.label)
            state.accesses = datas
            // console.log("ACCESSES SETTED", datas)
        },
        set_selected_app_user: (state, datas)=> {
            state.selected_app_user = datas
        },
        set_selected_company: (state, company)=> {
            // console.log("SET SELECTED COMPANY", company)
            state.selected_company.uid = company.uid
            state.selected_company.name = company.name
            if(company['has_accounting_software']){
                state.selected_company.has_accounting_software = company.has_accounting_software
                state.selected_company.has_vpc_to_bind = company.has_vpc_to_bind
            }
        },
        set_has_vpc_to_bind: (state, has_vpc_to_bind)=> {
            state.selected_company["has_vpc_to_bind"] = has_vpc_to_bind
        },
        set_has_accounting_software: (state, has_accounting_software)=> {
            state.selected_company["has_accounting_software"] = has_accounting_software
        },
        set_user_datas: (state, datas)=> {
            state.user_datas = datas
        },
        reset_selected_app_user: (state)=> {
            state.selected_app_user = {uid:'', lastname:'', firstname:''}
        },
        set_type: (state, payload)=> {
            state[payload.type_name+'_set'] = payload.datas
            // console.log("STORE ", state[payload.type_name+'_set'])
        },
        set_distribution_set: (state, datas)=> {
            state.distribution_set = datas
        },
        set_new_content: (state)=> {
            // console.log("STORE NEW CONTENT")
            state.new_content = !state.new_content
        },
    },
    actions: {
        set_authenticated: (context, payload)=>{
            // console.log("AUTH", payload)
            if(payload != null){
                context.commit("authenticate")
                context.commit("set_user_datas", payload)
                localStorage.setItem("authenticated", true)
                if(payload.profiles.indexOf('superadmin') != -1){
                    context.commit("set_selected_company", {uid:'', name:''})
                    localStorage.setItem("selected_company", JSON.stringify({uid:'', name:''}))
                }
                else{
                    context.commit("set_selected_company", {uid:payload.company.uid.toString(), name:payload.company.name, has_accounting_software:payload.company.has_accounting_software, has_vpc_to_bind:payload.company.has_vpc_to_bind})
                    localStorage.setItem("selected_company", JSON.stringify(payload.company))
                }
            }
            else {
                context.commit("logout")
            }
        },
    },
    modules: {
    }
})
